<div class="main-container layout-no-chrome d-flex">
    <div class="h-100p overflow-y-scroll w-100">
        <div class="custom_container">
            <div class="search-container">
                <div class="top-actions">
                    <div class="top-actions-left">
                        <button class="back-button" (click)="onBackButtonClick()">
                            <i class="fas fa-arrow-left"></i>
                            Back
                        </button>
                        <div class="view-tabs" *ngIf="isOsintAiAnalysisEnabled">
                            <button type="button" class="view-tab" [class.active]="activeViewTab === 'results'" (click)="setViewTab('results')">
                                <i class="fas fa-list"></i>
                                Results
                            </button>
                            <button type="button" class="view-tab" [class.active]="activeViewTab === 'ai-analysis'" (click)="setViewTab('ai-analysis')" *ngIf="isOsintAiAnalysisEnabled">
                                <i class="fas fa-wand-magic-sparkles"></i>
                                AI OSINT Analysis
                            </button>
                        </div>
                    </div>
                    <div class="top-query" *ngIf="selectedSearchResult">
                        <span class="top-query-value">{{ selectedSearchResult?.searched_gst }}</span>
                    </div>
                    <div class="top-actions-right" *ngIf="selectedSearchResult">
                        <div class="search-box">
                            <input class="search-input" type="text" placeholder="Search here" [(ngModel)]="searchTerm" (ngModelChange)="onSearchTermChange()" (input)="onSearchTermChange()" />
                        </div>
                    </div>
                </div>

                <div class="text-light" *ngIf="noRecords">No Records Found</div>

                <div *ngIf="isLoadingResults" class="loading-container text-center my-3">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="mt-2 text-main-color">Fetching results, please wait...</p>
                </div>

                <section class="result-status-cards" *ngIf="!isLoadingResults && selectedSearchResult && activeViewTab === 'results'" aria-label="Search result summary">
                    <button type="button" class="result-status-card is-found" (click)="openFoundDrillModal()">
                        <span class="result-status-accent" aria-hidden="true"></span>
                        <span class="result-status-icon" aria-hidden="true"><i class="bi bi-check-circle"></i></span>
                        <span class="result-status-count">{{ foundCount }}</span>
                        <span class="result-status-label">Found</span>
                        <i class="fas fa-chevron-right result-status-chevron" aria-hidden="true"></i>
                    </button>

                    <button type="button" class="result-status-card is-names" (click)="openNamesDrillModal()">
                        <span class="result-status-accent" aria-hidden="true"></span>
                        <span class="result-status-icon" aria-hidden="true"><i class="bi bi-person"></i></span>
                        <span class="result-status-count">{{ namesCount }}</span>
                        <span class="result-status-label">Names</span>
                        <i class="fas fa-chevron-right result-status-chevron" aria-hidden="true"></i>
                    </button>

                    <button type="button" class="result-status-card is-emails" (click)="openEmailsDrillModal()">
                        <span class="result-status-accent" aria-hidden="true"></span>
                        <span class="result-status-icon" aria-hidden="true"><i class="bi bi-envelope"></i></span>
                        <span class="result-status-count">{{ emailsCount }}</span>
                        <span class="result-status-label">Emails</span>
                        <i class="fas fa-chevron-right result-status-chevron" aria-hidden="true"></i>
                    </button>

                    <button type="button" class="result-status-card is-email-hints" *ngIf="emailHintsCount" (click)="openEmailHintsDrillModal()">
                        <span class="result-status-accent" aria-hidden="true"></span>
                        <span class="result-status-icon" aria-hidden="true"><i class="bi bi-at"></i></span>
                        <span class="result-status-count">{{ emailHintsCount }}</span>
                        <span class="result-status-label">Email Hints</span>
                        <i class="fas fa-chevron-right result-status-chevron" aria-hidden="true"></i>
                    </button>
                </section>

                <div class="results-grid gst-results-layout" *ngIf="!isLoadingResults && selectedSearchResult && activeViewTab === 'results'">
                    <section class="right-content">
                        <div id="source-results" class="source-card-grid abacus-card-grid gst-single-card-grid">
                            <article
                                class="result-card source-card gst-registry-card"
                                *ngFor="let card of displayedSearchResultDetails"
                                [class.is-not-found]="card.notFound"
                                [attr.id]="getPlatformSectionId(card.platform)"
                            >
                                <header class="gst-reg-header">
                                    <div class="gst-reg-brand">
                                        <div class="gst-reg-logo" aria-hidden="true">GST</div>
                                        <div class="gst-reg-brand-text">
                                            <h3 class="gst-reg-title">Company registry &amp; contacts</h3>
                                            <p class="gst-reg-subtitle">GST · Gst</p>
                                        </div>
                                    </div>
                                    <span
                                        class="gst-reg-status"
                                        [class.is-active]="!card.notFound && isGstStatusActive(card)"
                                        [class.is-inactive]="card.notFound || !isGstStatusActive(card)"
                                    >
                                        <span class="gst-reg-status-dot" aria-hidden="true"></span>
                                        {{ card.notFound ? 'Not found' : getGstStatusLabel(card) }}
                                    </span>
                                </header>

                                <p class="gst-reg-empty" *ngIf="card.notFound">No registry data found for this GSTIN.</p>

                                <div class="gst-field-grid" *ngIf="!card.notFound">
                                    <div class="gst-field-row">
                                        <span class="gst-field-icon" aria-hidden="true"><i class="bi bi-building"></i></span>
                                        <div class="gst-field-content">
                                            <span class="gst-field-label">Legal name</span>
                                            <span class="gst-field-value is-name">{{ getGstLegalName(card) }}</span>
                                        </div>
                                    </div>

                                    <div class="gst-field-row" *ngIf="getGstEntityBadge(card) as badge">
                                        <span class="gst-field-icon" aria-hidden="true"><i class="bi bi-briefcase"></i></span>
                                        <div class="gst-field-content">
                                            <span class="gst-field-label">Entity</span>
                                            <span class="gst-field-value">{{ badge }}</span>
                                        </div>
                                    </div>

                                    <div class="gst-field-row" *ngIf="getGstValue(card, 'registration_date') as regDate">
                                        <span class="gst-field-icon" aria-hidden="true"><i class="bi bi-calendar-event"></i></span>
                                        <div class="gst-field-content">
                                            <span class="gst-field-label">Registered</span>
                                            <span class="gst-field-value">{{ regDate }}</span>
                                        </div>
                                    </div>

                                    <div class="gst-field-row" *ngIf="getGstValue(card, 'last_update_date') as updDate">
                                        <span class="gst-field-icon" aria-hidden="true"><i class="bi bi-arrow-repeat"></i></span>
                                        <div class="gst-field-content">
                                            <span class="gst-field-label">Last update</span>
                                            <span class="gst-field-value">{{ updDate }}</span>
                                        </div>
                                    </div>

                                    <div class="gst-field-row" *ngIf="getGstDetail(card, 'email') as emailDetail">
                                        <span class="gst-field-icon" aria-hidden="true"><i class="bi bi-envelope"></i></span>
                                        <div class="gst-field-content">
                                            <span class="gst-field-label">Email</span>
                                            <div class="gst-field-value-row">
                                                <span class="gst-field-value">{{ utilsService.formatDisplayValue(emailDetail.value) }}</span>
                                                <button
                                                    *ngIf="shouldShowSearchIcon(emailDetail)"
                                                    type="button"
                                                    class="gst-reg-search-btn"
                                                    (click)="navigateToSearch(getOsintSearchType(emailDetail), emailDetail.value)"
                                                    title="Search email"
                                                    aria-label="Search email"
                                                >
                                                    <i class="fas fa-search" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="gst-field-row" *ngIf="getGstDetail(card, 'phone', 'mobile') as phoneDetail">
                                        <span class="gst-field-icon" aria-hidden="true"><i class="bi bi-telephone"></i></span>
                                        <div class="gst-field-content">
                                            <span class="gst-field-label">Phone</span>
                                            <div class="gst-field-value-row">
                                                <span class="gst-field-value">{{ utilsService.formatDisplayValue(phoneDetail.value) }}</span>
                                                <button
                                                    *ngIf="shouldShowSearchIcon(phoneDetail)"
                                                    type="button"
                                                    class="gst-reg-search-btn"
                                                    (click)="navigateToSearch(getOsintSearchType(phoneDetail), phoneDetail.value)"
                                                    title="Search phone"
                                                    aria-label="Search phone"
                                                >
                                                    <i class="fas fa-search" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="gst-field-row" *ngIf="getGstValue(card, 'gstin') as gstin">
                                        <span class="gst-field-icon" aria-hidden="true"><i class="bi bi-upc-scan"></i></span>
                                        <div class="gst-field-content">
                                            <span class="gst-field-label">GSTIN</span>
                                            <span class="gst-field-value">{{ gstin }}</span>
                                        </div>
                                    </div>

                                    <div class="gst-field-row is-wide" *ngIf="getGstValue(card, 'address', 'principal_place_address') as address">
                                        <span class="gst-field-icon" aria-hidden="true"><i class="bi bi-geo-alt"></i></span>
                                        <div class="gst-field-content">
                                            <span class="gst-field-label">Address</span>
                                            <span class="gst-field-value">{{ address }}</span>
                                        </div>
                                    </div>

                                    <div class="gst-field-row" *ngIf="getGstValue(card, 'state_jurisdiction') as stateJ">
                                        <span class="gst-field-icon" aria-hidden="true"><i class="bi bi-map"></i></span>
                                        <div class="gst-field-content">
                                            <span class="gst-field-label">State jurisdiction</span>
                                            <span class="gst-field-value">{{ stateJ }}</span>
                                        </div>
                                    </div>

                                    <div class="gst-field-row" *ngIf="getGstValue(card, 'center_jurisdiction') as centerJ">
                                        <span class="gst-field-icon" aria-hidden="true"><i class="bi bi-bank"></i></span>
                                        <div class="gst-field-content">
                                            <span class="gst-field-label">Center jurisdiction</span>
                                            <span class="gst-field-value">{{ centerJ }}</span>
                                        </div>
                                    </div>

                                    <ng-container *ngIf="getGstNatureTags(card) as tags">
                                        <div class="gst-field-row is-wide" *ngIf="tags.length">
                                            <span class="gst-field-icon" aria-hidden="true"><i class="bi bi-tags"></i></span>
                                            <div class="gst-field-content">
                                                <span class="gst-field-label">Nature of business</span>
                                                <div class="gst-reg-tags">
                                                    <span class="gst-reg-tag" *ngFor="let tag of tags">{{ tag }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </article>
                        </div>

                        <div id="google-results" class="google-results-section" *ngIf="showGoogleResults">
                            <div class="card-header-green google-header">
                                <svg class="google-icon-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
                                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                                </svg>
                                <span>Google Results</span>
                                <a *ngIf="googleSearchHref" class="google-open-link" [href]="googleSearchHref" target="_blank" rel="noopener noreferrer">Open in Google</a>
                            </div>
                            <div class="google-query-selector" *ngIf="googleQueryVariants.length > 1" role="tablist" aria-label="Google search query variants">
                                <button type="button" class="google-query-chip" *ngFor="let variant of googleQueryVariants" [class.active]="selectedGoogleQueryId === variant.id" [attr.title]="variant.query" [attr.aria-selected]="selectedGoogleQueryId === variant.id" (click)="selectGoogleQuery(variant)">
                                    {{ variant.label }}
                                </button>
                            </div>
                            <div class="google-results-container">
                                <iframe *ngIf="googleResultsUrl" class="google-results-iframe" [src]="googleResultsUrl" title="Google Results" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>

                        <div class="notes-section">
                            <div class="notes-header">Add Notes</div>
                            <div class="notes-content">
                                <textarea class="note-input" maxlength="300" placeholder="Notes" [(ngModel)]="notes"></textarea>
                                <div class="notes-footer">
                                    <span class="character-count">{{ notes.length }}/300</span>
                                    <button class="update-button" (click)="onUpdateNotesButtonClick()">Update Notes</button>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <div class="ai-analysis-view" *ngIf="isOsintAiAnalysisEnabled && !isLoadingResults && selectedSearchResult && activeViewTab === 'ai-analysis'">
                    <app-osint-ai-analysis [searchId]="searchId" type="gst" [queryValue]="selectedSearchResult?.searched_gst || ''" [hasSourceData]="searchResultDetailsFiltered.length > 0 || searchResultImages.length > 0 || aggregatedNames.length > 0 || aggregatedEmails.length > 0 || aggregatedEmailHints.length > 0"></app-osint-ai-analysis>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="image-modal-overlay" *ngIf="selectedImage" (click)="closeImageModal()">
    <div class="image-modal-content" (click)="$event.stopPropagation()">
        <button class="image-modal-close" (click)="closeImageModal()" aria-label="Close modal">
            <i class="fas fa-times"></i>
        </button>
        <button *ngIf="canStartImageSearch(selectedImage)" type="button" class="image-search-trigger is-modal" (click)="startImageSearchFromSrc(selectedImage, $event)" title="Image Search" aria-label="Image Search">
            <i class="fas fa-magnifying-glass" aria-hidden="true"></i>
            <span>Image Search</span>
        </button>
        <img [src]="selectedImage.src" [alt]="selectedImage.name" class="image-modal-img" />
    </div>
</div>

<div class="found-drill-overlay" *ngIf="showFoundDrillModal" (click)="closeFoundDrillModal()">
    <div class="found-drill-panel" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="found-drill-title">
        <header class="found-drill-header">
            <div class="found-drill-heading">
                <div class="found-drill-title-row">
                    <h2 id="found-drill-title">Found</h2>
                    <span class="found-drill-count">{{ foundCount }} platforms</span>
                </div>
                <p class="found-drill-subtitle">A profile is live on each of these under this GSTIN.</p>
            </div>
            <div class="found-drill-actions">
                <div class="found-drill-search">
                    <i class="fas fa-search" aria-hidden="true"></i>
                    <input type="text" placeholder="Search platforms" [(ngModel)]="foundPlatformSearchTerm" aria-label="Search found platforms" />
                </div>
                <button type="button" class="found-drill-close" (click)="closeFoundDrillModal()" aria-label="Close found platforms">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </header>

        <div class="found-drill-grid" *ngIf="filteredFoundPlatforms.length; else noFoundMatches">
            <article class="found-drill-card" *ngFor="let platform of filteredFoundPlatforms" (click)="onFoundPlatformClick(platform)" (keydown.enter)="onFoundPlatformClick(platform)" (keydown.space)="$event.preventDefault(); onFoundPlatformClick(platform)" tabindex="0" role="button" [attr.aria-label]="'Open ' + getDrillPlatformName(platform) + ' profile'">
                <ng-container *ngIf="getPlatformImageForCard(platform) as platformImage; else foundDrillLogo">
                    <div class="found-drill-thumb-wrap">
                        <img class="found-drill-thumb" [src]="platformImage.src" [alt]="getDrillPlatformName(platform)" referrerpolicy="no-referrer" (error)="onPictureError($event)" />
                        <span class="found-drill-badge">
                            <img [src]="getDrillPlatformIcon(platform)" [alt]="getDrillPlatformName(platform)" (error)="onIconError($event)" />
                        </span>
                    </div>
                </ng-container>
                <ng-template #foundDrillLogo>
                    <div class="found-drill-icon-wrap">
                        <img class="found-drill-icon" [src]="getDrillPlatformIcon(platform)" [alt]="getDrillPlatformName(platform)" (error)="onIconError($event)" />
                    </div>
                </ng-template>
                <div class="found-drill-card-text">
                    <span class="found-drill-platform">{{ getDrillPlatformName(platform) }}</span>
                    <span class="found-drill-meta" *ngIf="getDrillPlatformUrlText(platform) as profileUrl">{{ profileUrl }}</span>
                </div>
                <i class="fas fa-chevron-right found-drill-chevron" aria-hidden="true"></i>
            </article>
        </div>

        <ng-template #noFoundMatches>
            <div class="found-drill-empty">No platforms match your search.</div>
        </ng-template>
    </div>
</div>

<div class="found-drill-overlay" *ngIf="showNamesDrillModal" (click)="closeNamesDrillModal()">
    <div class="found-drill-panel" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="names-drill-title">
        <header class="found-drill-header">
            <div class="found-drill-heading">
                <div class="found-drill-title-row">
                    <h2 id="names-drill-title">Names</h2>
                    <span class="found-drill-count">{{ namesCount }} confirmed</span>
                </div>
                <p class="found-drill-subtitle">These names were recovered under this GSTIN.</p>
            </div>
            <div class="found-drill-actions">
                <div class="found-drill-search">
                    <i class="fas fa-search" aria-hidden="true"></i>
                    <input type="text" placeholder="Search names" [(ngModel)]="namesSearchTerm" aria-label="Search names" />
                </div>
                <button type="button" class="found-drill-close" (click)="closeNamesDrillModal()" aria-label="Close names">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </header>

        <div class="found-drill-grid names-drill-grid" *ngIf="filteredNameDrillEntries.length; else noNameMatches">
            <article class="found-drill-card" *ngFor="let entry of filteredNameDrillEntries" (click)="onNameDrillClick(entry.platforms)" (keydown.enter)="onNameDrillClick(entry.platforms)" (keydown.space)="$event.preventDefault(); onNameDrillClick(entry.platforms)" tabindex="0" role="button" [attr.aria-label]="'Open sources for ' + entry.name">
                <div class="found-drill-thumb-wrap">
                    <img class="found-drill-thumb" [src]="getNameDrillThumb(entry.platforms)" [alt]="entry.name" referrerpolicy="no-referrer" (error)="onPictureError($event)" />
                    <span class="found-drill-badge">
                        <img [src]="getNameDrillPlatformIcon(entry.platforms)" [alt]="getNameDrillPrimaryPlatform(entry.platforms)?.platform || 'platform'" (error)="onIconError($event)" />
                    </span>
                </div>
                <div class="found-drill-card-text">
                    <span class="found-drill-platform" [attr.title]="entry.name">{{ entry.name }}</span>
                    <span class="found-drill-meta">{{ getNameDrillSubtitle(entry.platforms) }}</span>
                </div>
                <button type="button" class="identity-copy-btn" (click)="$event.stopPropagation(); copySummaryValue(entry.name)" [attr.aria-label]="'Copy ' + entry.name" title="Copy">
                    <i class="far fa-copy" aria-hidden="true"></i>
                </button>
            </article>
        </div>

        <ng-template #noNameMatches>
            <div class="found-drill-empty">No names match your search.</div>
        </ng-template>
    </div>
</div>

<div class="found-drill-overlay" *ngIf="showEmailsDrillModal" (click)="closeEmailsDrillModal()">
    <div class="found-drill-panel" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="emails-drill-title">
        <header class="found-drill-header">
            <div class="found-drill-heading">
                <div class="found-drill-title-row">
                    <h2 id="emails-drill-title">Email addresses</h2>
                    <span class="found-drill-count">{{ emailsCount }} confirmed</span>
                </div>
                <p class="found-drill-subtitle">These email addresses were recovered under this GSTIN.</p>
            </div>
            <div class="found-drill-actions">
                <div class="found-drill-search">
                    <i class="fas fa-search" aria-hidden="true"></i>
                    <input type="text" placeholder="Search emails" [(ngModel)]="emailsSearchTerm" aria-label="Search emails" />
                </div>
                <button type="button" class="found-drill-close" (click)="closeEmailsDrillModal()" aria-label="Close emails">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </header>

        <div class="found-drill-grid names-drill-grid" *ngIf="filteredEmails.length; else noEmailMatches">
            <article class="found-drill-card is-static" *ngFor="let email of filteredEmails">
                <div class="emails-drill-icon" aria-hidden="true"><i class="fas fa-envelope"></i></div>
                <div class="found-drill-card-text">
                    <span class="found-drill-platform" [attr.title]="email">{{ email }}</span>
                </div>
                <mat-icon *ngIf="isValidSearchValue(email)" class="search-icon" (click)="navigateToSearch('email', email)" title="Search for {{email}}">search</mat-icon>
                <button type="button" class="identity-copy-btn" (click)="copySummaryValue(email)" [attr.aria-label]="'Copy ' + email" title="Copy">
                    <i class="far fa-copy" aria-hidden="true"></i>
                </button>
            </article>
        </div>

        <ng-template #noEmailMatches>
            <div class="found-drill-empty">No emails match your search.</div>
        </ng-template>
    </div>
</div>

<div class="found-drill-overlay" *ngIf="showEmailHintsDrillModal" (click)="closeEmailHintsDrillModal()">
    <div class="found-drill-panel" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="email-hints-drill-title">
        <header class="found-drill-header">
            <div class="found-drill-heading">
                <div class="found-drill-title-row">
                    <h2 id="email-hints-drill-title">Email Hints</h2>
                    <span class="found-drill-count">{{ emailHintsCount }} confirmed</span>
                </div>
                <p class="found-drill-subtitle">These email hints were recovered under this GSTIN.</p>
            </div>
            <div class="found-drill-actions">
                <div class="found-drill-search is-no-icon">
                    <input type="text" placeholder="Search email hints" [(ngModel)]="emailHintsSearchTerm" aria-label="Search email hints" />
                </div>
                <button type="button" class="found-drill-close" (click)="closeEmailHintsDrillModal()" aria-label="Close email hints">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </header>

        <div class="found-drill-grid names-drill-grid" *ngIf="filteredEmailHints.length; else noEmailHintMatches">
            <article class="found-drill-card is-static" *ngFor="let hint of filteredEmailHints">
                <div class="email-hints-drill-icon" aria-hidden="true"><i class="fas fa-at"></i></div>
                <div class="found-drill-card-text">
                    <span class="found-drill-platform" [attr.title]="hint">{{ hint }}</span>
                </div>
                <button type="button" class="identity-copy-btn" (click)="copySummaryValue(hint)" [attr.aria-label]="'Copy ' + hint" title="Copy">
                    <i class="far fa-copy" aria-hidden="true"></i>
                </button>
            </article>
        </div>

        <ng-template #noEmailHintMatches>
            <div class="found-drill-empty">No email hints match your search.</div>
        </ng-template>
    </div>
</div>